var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafficIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "96px",
    height: "96px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 23 1 L 23 23 L 1 23 Z M 1 1 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 19 1 C 21.210938 1 23 2.789062 23 5 L 23 19 C 23 21.210938 21.210938 23 19 23 L 5 23 C 2.789062 23 1 21.210938 1 19 L 1 5 C 1 2.789062 2.789062 1 5 1 Z M 5 1 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 3 L 16 3 L 16 23 L 1 23 Z M 1 3 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 19 1 C 21.210938 1 23 2.789062 23 5 L 23 19 C 23 21.210938 21.210938 23 19 23 L 5 23 C 2.789062 23 1 21.210938 1 19 L 1 5 C 1 2.789062 2.789062 1 5 1 Z M 5 1 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 12 L 23 12 L 23 18 L 9 18 Z M 9 12 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 19 1 C 21.210938 1 23 2.789062 23 5 L 23 19 C 23 21.210938 21.210938 23 19 23 L 5 23 C 2.789062 23 1 21.210938 1 19 L 1 5 C 1 2.789062 2.789062 1 5 1 Z M 5 1 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 7 L 12 7 L 12 23 L 1 23 Z M 1 7 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 19 1 C 21.210938 1 23 2.789062 23 5 L 23 19 C 23 21.210938 21.210938 23 19 23 L 5 23 C 2.789062 23 1 21.210938 1 19 L 1 5 C 1 2.789062 2.789062 1 5 1 Z M 5 1 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 4 L 15 4 L 15 23 L 1 23 Z M 1 4 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 19 1 C 21.210938 1 23 2.789062 23 5 L 23 19 C 23 21.210938 21.210938 23 19 23 L 5 23 C 2.789062 23 1 21.210938 1 19 L 1 5 C 1 2.789062 2.789062 1 5 1 Z M 5 1 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 14 L 23 14 L 23 16 L 12 16 Z M 12 14 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 19 1 C 21.210938 1 23 2.789062 23 5 L 23 19 C 23 21.210938 21.210938 23 19 23 L 5 23 C 2.789062 23 1 21.210938 1 19 L 1 5 C 1 2.789062 2.789062 1 5 1 Z M 5 1 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(90.980393%,92.941177%,94.509804%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 26,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(72.156864%,75.294119%,78.039217%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 48 110 L 48 54 C 48 36.671875 39.328125 28 22 28 L -10 28 ",
    transform: "matrix(0.25,0,0,0.25,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(72.156864%,75.294119%,78.039217%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 48 60 L 110 60 ",
    transform: "matrix(0.25,0,0,0.25,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,65.882355%,32.549021%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 42 110 L 42 54 C 42 40.671875 35.328125 34 22 34 L -10 34 ",
    transform: "matrix(0.25,0,0,0.25,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(91.764706%,26.274511%,20.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 54 110 L 54 54 C 54 32.671875 43.328125 22 22 22 L -10 22 ",
    transform: "matrix(0.25,0,0,0.25,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "rgb(98.431373%,73.725492%,1.568628%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 52 60 L 110 60 ",
    transform: "matrix(0.25,0,0,0.25,0,0)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(4.313726%,54.11765%,54.11765%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 20 4 L 76 4 C 84.84375 4 92 11.15625 92 20 L 92 76 C 92 84.84375 84.84375 92 76 92 L 20 92 C 11.15625 92 4 84.84375 4 76 L 4 20 C 4 11.15625 11.15625 4 20 4 Z M 20 4 ",
    transform: "matrix(0.25,0,0,0.25,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficIcon);
export default __webpack_public_path__ + "static/media/trafficIcon.9a21bfd2fbb51f7fd638eb484b49ec74.svg";
export { ForwardRef as ReactComponent };